import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackType, StackWidth, TabTypeTokens, WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, fetchActiveIndex, getDateMonthYearFromEpoch, isMobile, setAppHeader, showARNNumber } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { onChangeTab } from "../collateral/action";
import { ACTION_ACCOUNT, PAN_TYPE } from "./types";
import { getEnteredPassword, getReEnteredPassword, navigateToPayoutDetails, onEditPayoutDetails, onEditProfileDetails, onEnterArnDetails, onEnteringPayoutDetails, onEnteringProfileData, onLoad, onSavePayoutDetails, onSaveProfileDetails, onSelectPanType, onSetNewPassword, openMenu, sendPasswordToBackend, toggleAction } from "./action";
import { partnerApi } from "../../configs/api";
import { getAppHeader, RegexConfig } from "../../configs/config";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { Platform } from "react-native";
import { checkIfPartnerDetailsAdded, ShowNewRmContactButton } from '../partnerWeb_Dashboard/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
const _isMobile = isMobile();
const panTypeData = [
    { label: 'Resident Individual (Self)', value: PAN_TYPE.RESIDENT_INDIVIDUAL_SELF },
    { label: 'Resident Individual (Other)', value: PAN_TYPE.RESIDENT_INDIVIDUAL_OTHER },
    { label: 'Private Limited Company', value: PAN_TYPE.PRIVATE_LIMITED },
    { label: 'Limited Liability Partnership', value: PAN_TYPE.LLP },
    { label: 'Sole proprietor', value: PAN_TYPE.SOLE_PROPRIETOR },
    { label: 'Partnership', value: PAN_TYPE.PARTNERSHIP },
    { label: 'HUF', value: PAN_TYPE.HUF },
    { label: 'OPC (One-Person Company)', value: PAN_TYPE.OPC },
    { label: 'Other', value: PAN_TYPE.OTHER },
];
export const template = async (name, phoneNumber, emailId, companyName, arnNumber, panType, gstNumber, panNumber, ifscCode, bankAccountNumber, detailsFor, isFromStartPayoutonDashboard, passwordHash, partnerAccountType, isFirstTime, otherPanTypeDetail, showNewRmContactButton, rmData, bankAccountVerified, isFromPayOutDetails, bankAddedOn, getActiveIndexTab) => ({
    layout: {
        id: ROUTE.MY_ACCOUNT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'accountDetailsMainStack', type: WIDGET.STACK },
            isMobile() ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.MY_ACCOUNT,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.MY_ACCOUNT),
        ...await SideBarBuilderDS(ROUTE.MY_ACCOUNT),
        ...await BottomNavBuilderDS(ROUTE.MY_ACCOUNT),
        accountDetailsMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : {}
            },
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "payoutDetailsHeading", type: WIDGET.TEXT },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: 'tabb', type: WIDGET.TABS }
            ]
        },
        tabb: {
            active: (isFromStartPayoutonDashboard || isFromPayOutDetails) ? 1 : fetchActiveIndex(getActiveIndexTab),
            type: TabTypeTokens.DEFAULT,
            customWidth: _isMobile ? 360 : 552,
            options: [
                {
                    label: "Profile details",
                    disabled: false
                },
                {
                    label: "Payout details",
                    disabled: false
                },
                {
                    label: "Login details",
                    disabled: false
                }
            ],
            widgetItems: [
                {
                    id: "profileDetailsStack", type: WIDGET.STACK,
                },
                {
                    id: "payoutDetailsStackDC", type: WIDGET.PAYOUT_DASHBOARD_PAGE,
                },
                {
                    id: "showMobileNumberStack", type: WIDGET.STACK,
                }
            ]
        },
        payoutDetailsStackDC: {
            width: StackWidth.CONTENT,
            bankAddedOn,
            panType,
            panNumber,
            gstNumber,
            bankAccountNumber,
            ifscCode,
            bankAccountVerified,
            navigateAction: {
                type: ACTION.NAVIGATE_PAYOUT_DETIALS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: {},
            },
        },
        tabStack: {
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: "tabb", type: WIDGET.TABS }
            ]
        },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL
        },
        space32: {
            size: SizeTypeTokens.Size32
        },
        profileDetailsStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "editProfileButtonStack", type: WIDGET.STACK },
                { id: "editButtonSpace", type: WIDGET.STACK },
                { id: "nameInputStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "mobileNumberStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "communicationMailStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                showARNNumber(partnerAccountType) ? { id: "aRNStack", type: WIDGET.STACK } : {},
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "companyNameStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "successCTA", type: WIDGET.STACK },
                { id: "errorCTA", type: WIDGET.STACK },
                { id: "errorCTASpace", type: WIDGET.STACK },
                { id: "ctaSaveProfileStack", type: WIDGET.STACK }
            ]
        },
        editButtonSpace: {
            type: StackType.column,
            widgetItems: [
                { id: "space32", type: WIDGET.SPACE }
            ]
        },
        errorCTASpace: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "space14", type: WIDGET.SPACE }
            ]
        },
        space14: {
            size: SizeTypeTokens.SIZE14
        },
        editProfileButtonStack: {
            type: StackType.column,
            widgetItems: [
                { id: "editProfileButton", type: WIDGET.BUTTON }
            ]
        },
        editProfileButton: {
            height: 32,
            customWidth: 139,
            label: 'Edit details',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.CONTENT,
            action: {
                type: ACTION_ACCOUNT.ON_CLICK_PROFILE_EDIT,
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
        editPayoutDetailsStack: {
            type: StackType.column,
            widgetItems: [
                { id: "editPayoutDetailButton", type: WIDGET.BUTTON }
            ]
        },
        setNewPasswordStack: {
            minWidth: 139,
            type: StackType.column,
            widgetItems: [
                { id: "setNewPasswordButton", type: WIDGET.BUTTON }
            ]
        },
        setNewPasswordButton: {
            height: 32,
            label: passwordHash !== null ? 'Change password' : 'Set new password',
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.CONTENT,
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            action: {
                type: ACTION_ACCOUNT.ON_SET_NEW_PASSWORD,
                routeId: ROUTE.MY_ACCOUNT,
                payload: {
                    value: passwordHash
                }
            },
        },
        editPayoutDetailButton: {
            customWidth: 139,
            height: 32,
            label: 'Edit details',
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.CONTENT,
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            action: {
                type: ACTION_ACCOUNT.ON_CLICK_PAYOUT_EDIT,
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
        profileDetailsHeading: {
            label: 'Profile details',
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins
        },
        nameInputStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "nameInput", type: WIDGET.INPUT }
            ]
        },
        mobileNumberStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "mobileNumberInput", type: WIDGET.INPUT }
            ]
        },
        communicationMailStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "communicationMailInput", type: WIDGET.INPUT }
            ]
        },
        companyNameStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "companyNameInput", type: WIDGET.INPUT }
            ]
        },
        nameInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DISABLED,
            title: "Name *",
            isFocus: false,
            value: `${name === null || name === "null" ? '' : name}`,
            customWidth: 348,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PROFILE_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'name' },
            },
            keyboardType: KeyboardTypeToken.default,
        },
        mobileNumberInput: {
            state: InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            title: "Mobile number",
            isFocus: false,
            customWidth: 348,
            value: `${phoneNumber === null || phoneNumber === "null" ? '' : phoneNumber}`,
            keyboardType: KeyboardTypeToken.numberPad,
        },
        communicationMailInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DISABLED,
            title: "Email",
            isFocus: false,
            customWidth: 348,
            value: `${emailId === null || emailId === "null" ? '' : emailId}`,
            keyboardType: KeyboardTypeToken.default,
        },
        companyNameInput: {
            state: InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            isFocus: false,
            value: `${companyName === null || companyName === "null" || companyName === undefined ? '' : companyName}`,
            customWidth: 348,
            title: "Company name (Optional)",
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PROFILE_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'companyName' },
            },
        },
        ctaSaveProfileStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "ctaSaveProfileDetailsButton", type: WIDGET.BUTTON }
            ]
        },
        ctaSaveProfileDetailsButton: {
            label: 'Save details',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.CONTENT,
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            height: 32,
            action: {
                type: ACTION_ACCOUNT.ON_SAVE_PROFILE_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
        payoutDetailsHeading: {
            label: 'Account details',
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins
        },
        payoutDetailsStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "editPayoutDetailsStack", type: WIDGET.STACK },
                { id: "editPayoutDetailsSpace", type: WIDGET.STACK },
                { id: "panTypeStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "otherPanTypeInputStack", type: WIDGET.STACK },
                { id: "otherPANInputSpaceStack", type: WIDGET.STACK },
                { id: "payout_details_panInput", type: WIDGET.INPUT },
                { id: "gstSpace", type: WIDGET.STACK },
                { id: "gstStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "bankAccountStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "reEnterBankStack", type: WIDGET.STACK },
                { id: "reEnterBankSpaceStack", type: WIDGET.STACK },
                { id: "ifscInputStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                showARNNumber(partnerAccountType) ? { id: "aRNStack", type: WIDGET.STACK } : {},
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "successPayoutCTA", type: WIDGET.STACK },
                { id: "errorPayoutCTA", type: WIDGET.STACK },
                { id: "ctaSavePayoutDetailsButtonStack", type: WIDGET.STACK }
            ]
        },
        showMobileNumberStack: {
            type: StackType.column,
            widgetItems: [
                { id: "topSpaceStack", type: WIDGET.STACK },
                { id: "setNewPasswordStack", type: WIDGET.STACK },
                { id: "space32Stack", type: WIDGET.STACK },
                { id: "loginSuccessCTA", type: WIDGET.STACK },
                { id: "showMobileInputStack", type: WIDGET.STACK },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "createPasswordStack", type: WIDGET.STACK },
                { id: "savePasswordStack", type: WIDGET.STACK },
            ]
        },
        loginSuccessCTA: {
            type: StackType.row,
            hide: true,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "successIcon", type: WIDGET.ICON },
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "successText", type: WIDGET.TEXT }
            ]
        },
        topSpaceStack: {
            type: StackType.column,
            hide: false,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
            ]
        },
        createPasswordStack: {
            type: StackType.column,
            minWidth: 348,
            hide: passwordHash !== null,
            widgetItems: [
                { id: "createPasswordShowInput", type: WIDGET.INPUT }
            ]
        },
        space32Stack: {
            type: StackType.column,
            widgetItems: [
                { id: "space32", type: WIDGET.SPACE }
            ]
        },
        savePasswordStack: {
            type: StackType.column,
            minWidth: 348,
            hide: true,
            widgetItems: [
                { id: "createPasswordInput", type: WIDGET.INPUT },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "reEnterPasswordInput", type: WIDGET.INPUT },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "saveLoginDetails", type: WIDGET.BUTTON },
            ]
        },
        spaceSize42: {
            size: SizeTypeTokens.SIZE42
        },
        showMobileInputStack: {
            type: StackType.column,
            minWidth: 348,
            hide: passwordHash !== null,
            widgetItems: [{
                    id: "showMobileNumberInput", type: WIDGET.INPUT
                }]
        },
        showMobileNumberInput: {
            state: InputStateToken.DISABLED,
            title: 'Mobile number',
            charLimit: 10,
            placeholder: `${phoneNumber === null || phoneNumber === "null" ? '' : phoneNumber}`,
        },
        createPasswordInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            secureTextEntry: true,
            isFocus: true,
            keyboardType: KeyboardTypeToken.default,
            title: passwordHash !== null ? 'New password' : 'Password',
            placeholder: passwordHash === null ? 'Password not set' : 'Enter new password',
            action: {
                routeId: ROUTE.MY_ACCOUNT,
                type: ACTION_ACCOUNT.ENTER_PASSWORD,
                payload: { value: "", widgetID: 'createPasswordInput' },
            }
        },
        createPasswordShowInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DISABLED,
            secureTextEntry: true,
            isFocus: true,
            keyboardType: KeyboardTypeToken.default,
            title: passwordHash !== null ? 'New password' : 'Password',
            placeholder: 'Password not set',
            action: {
                routeId: ROUTE.MY_ACCOUNT,
                type: ACTION_ACCOUNT.ENTER_PASSWORD,
                payload: { value: "", widgetID: 'createPasswordInput' },
            }
        },
        reEnterPasswordInput: {
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            secureTextEntry: true,
            isFocus: false,
            showPasswordIcon: true,
            togglePasswordIcon: true,
            keyboardType: KeyboardTypeToken.default,
            title: 'Confirm password',
            placeholder: 'Confirm Password',
            action: {
                routeId: ROUTE.MY_ACCOUNT,
                type: ACTION_ACCOUNT.GET_REENTERED_PASSWORD,
                payload: { value: "", widgetID: 'reEnterPasswordInput' },
            },
            toggleAction: {
                routeId: ROUTE.MY_ACCOUNT,
                type: ACTION_ACCOUNT.TOGGLE_PASSWORD
            },
        },
        successPayoutCTASpace: {
            type: StackType.column,
            widgetItems: [
                { id: "spaceXL", type: WIDGET.SPACE }
            ]
        },
        saveLoginDetails: {
            label: 'Save details',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.CONTENT,
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            height: 32,
            action: {
                type: ACTION_ACCOUNT.SEND_PASSWORD,
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
        successPayoutCTA: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "successIcon", type: WIDGET.ICON },
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "successText", type: WIDGET.TEXT }
            ]
        },
        errorPayoutCTA: {
            type: StackType.row,
            hide: true,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "errorIcon", type: WIDGET.ICON },
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "errorText", type: WIDGET.TEXT }
            ]
        },
        editPayoutDetailsSpace: {
            type: StackType.column,
            widgetItems: [
                { id: "space32", type: WIDGET.SPACE }
            ]
        },
        reEnterBankSpaceStack: {
            type: StackType.column,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE }
            ]
        },
        detailsSpace: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE }
            ]
        },
        gstSpace: {
            type: StackType.column,
            hide: panType === PAN_TYPE.INDIVIDUAL,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE }
            ]
        },
        otherPANInputSpaceStack: {
            type: StackType.column,
            hide: panType !== PAN_TYPE.OTHER,
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE }
            ]
        },
        gstStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "gstNumberInput", type: WIDGET.INPUT }
            ]
        },
        bankAccountStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "bankAccountInput", type: WIDGET.INPUT }
            ]
        },
        reEnterBankStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "reEnterBankInput", type: WIDGET.INPUT }
            ]
        },
        ifscInputStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "ifscInput", type: WIDGET.INPUT }
            ]
        },
        aRNStack: {
            width: StackWidth.CONTENT,
            type: StackType.column,
            widgetItems: [
                { id: "ARNNumberInput", type: WIDGET.INPUT }
            ]
        },
        payout_details_panInput: {
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            regex: RegexConfig.PAN,
            charLimit: 10,
            isUpperCase: true,
            isFocus: false,
            title: "PAN number *",
            value: `${panNumber === "null" || panNumber === null ? '' : panNumber}`,
            customWidth: 348,
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'panNumber' },
            },
            showErrorOnFocus: false
        },
        successCTA: {
            type: StackType.row,
            hide: true,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "successIcon", type: WIDGET.ICON },
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "successText", type: WIDGET.TEXT }
            ]
        },
        successIcon: {
            name: IconTokens.SuccessIcon,
            size: IconSizeTokens.SM
        },
        successText: {
            label: 'Details updated successfully',
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.System_Happy,
        },
        errorCTA: {
            type: StackType.row,
            hide: true,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "errorIcon", type: WIDGET.ICON },
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "errorText", type: WIDGET.TEXT }
            ]
        },
        errorIcon: {
            name: IconTokens.Failed,
            size: IconSizeTokens.MD
        },
        errorText: {
            label: 'Submission failed, please retry ',
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Red_90,
        },
        spaceMD: {
            size: SizeTypeTokens.MD
        },
        bankAccountInput: {
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            isFocus: false,
            title: "Bank account number *",
            secureTextEntry: true,
            value: `${bankAccountNumber === "null" || bankAccountNumber === null ? '' : bankAccountNumber.replace(/./g, '*')}`,
            customWidth: 348,
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'bankAccountNumber' },
            },
        },
        reEnterBankInput: {
            type: InputTypeToken.DEFAULT,
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            isFocus: false,
            value: `${bankAccountNumber === "null" || bankAccountNumber === null ? '' : bankAccountNumber}`,
            title: "Re-enter bank account number *",
            customWidth: 348,
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'reEnterBankAccountNumber' },
            },
            showErrorOnFocus: false
        },
        ifscInput: {
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            title: "IFSC *",
            isFocus: false,
            regex: RegexConfig.IFSC,
            value: `${ifscCode === "null" || ifscCode === null ? '' : ifscCode}`,
            customWidth: 348,
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'ifscNumber' },
            },
        },
        gstNumberInput: {
            state: InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            title: "GST number",
            isFocus: false,
            placeholder: 'GST Number (Optional)',
            value: `${gstNumber === "null" || gstNumber === null ? '' : gstNumber}`,
            customWidth: 348,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'gstNumber' },
            },
        },
        ARNNumberInput: {
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            placeholder: 'ARN Number (Optional)',
            title: "ARN number (Optional)",
            value: `${arnNumber === "null" || arnNumber === null ? '' : arnNumber}`,
            isFocus: false,
            customWidth: 348,
            onlyNumeric: true,
            keyboardType: KeyboardTypeToken.default,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PROFILE_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'arnNumber' },
            },
        },
        ctaSavePayoutDetailsButtonStack: {
            type: StackType.column,
            hide: !isFirstTime,
            widgetItems: [
                { id: "ctaSavePayoutDetailsButton", type: WIDGET.BUTTON }
            ]
        },
        ctaSavePayoutDetailsButton: {
            label: 'Save details',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.CONTENT,
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            height: 32,
            action: {
                type: ACTION_ACCOUNT.ON_SAVE_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
        panTypeStack: {
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'panTypeInput', type: WIDGET.PARTNER_DROP_DOWN_INPUT }
            ]
        },
        otherPanTypeInputStack: {
            width: StackWidth.MATCH_PARENT,
            hide: panType !== PAN_TYPE.OTHER,
            widgetItems: [
                { id: 'otherPanTypeInput', type: WIDGET.INPUT }
            ]
        },
        otherPanTypeInput: {
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            isFocus: false,
            title: "Enter PAN Type",
            placeholder: 'PAN Type',
            customWidth: 348,
            value: otherPanTypeDetail !== undefined || otherPanTypeDetail !== "" ? otherPanTypeDetail : '',
            keyboardType: KeyboardTypeToken.numberPad,
            action: {
                type: ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS,
                routeId: ROUTE.MY_ACCOUNT,
                payload: { value: "", widgetID: 'otherPANType' },
            },
        },
        spaceXL: {
            size: SizeTypeTokens.XXL
        },
        panTypeInput: {
            label: `${panType ? panType : 'Select PAN Type *'}`,
            data: panTypeData,
            width: 350,
            state: isFirstTime ? InputStateToken.DEFAULT : InputStateToken.DISABLED,
            action: {
                type: ACTION_ACCOUNT.ON_SELECT_PAN_TYPE,
                payload: {
                    value: null,
                    widgetID: 'panTypeInput',
                },
                routeId: ROUTE.MY_ACCOUNT,
            },
        },
    },
});
export const myAccountMF = {
    onLoad: async ({ network, openNewTab, instrumentTrack, ...props }, { isFromPayOutDetails }) => {
        const getActiveIndexTab = await AsyncStorage?.getItem("activeIndexTab");
        if (getActiveIndexTab === 'payout' || getActiveIndexTab === 'profile' || getActiveIndexTab === 'login') {
            appendURlWithParam(`my_account/${getActiveIndexTab}`);
        }
        else
            appendURlWithParam('my_account');
        await setAppHeader();
        await checkIfPartnerDetailsAdded({
            network: network,
            openNewTab: openNewTab
        });
        const userContextResponse = await network.post(partnerApi.userContext, {}, {
            headers: await getAppHeader(),
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        instrumentTrack("ACCOUNT_DETAILS_PAGE_VIEWED");
        const partnerAccountId = userContextResponse.data.linkedPartnerAccounts[0].accountId;
        const passwordHash = userContextResponse.data.linkedPartnerAccounts[0].passwordHash;
        const partnerAccountType = userContextResponse.data.linkedPartnerAccounts[0].partnerAccountType;
        const response = await network.get(`${partnerApi.clientList}${partnerAccountId}`, {
            headers: await getAppHeader(),
        });
        const url = Platform.OS === 'web' ? window.location.href : '';
        const uRL = new URL(url);
        const isFromStartPayoutonDashboard = uRL.searchParams.has('payoutDetails');
        const partnerResponse = response?.data;
        const name = partnerResponse?.partnerName || "";
        const phoneNumber = partnerResponse?.accountHolderPhoneNumber || "";
        const emailId = partnerResponse?.accountHolderEmail || "";
        const companyName = partnerResponse?.partnerProfileDetails?.companyName || "";
        const arnNumber = partnerResponse?.partnerProfileDetails?.arnNo || "";
        const panType = partnerResponse?.partnerProfileDetails?.panType || "";
        const gstNumber = partnerResponse?.partnerProfileDetails?.gstNo || "";
        const panNumber = partnerResponse?.partnerProfileDetails?.panNo || "";
        const ifscCode = partnerResponse?.partnerProfileDetails?.bankAccountIFSCCode || "";
        const bankAccountNumber = partnerResponse?.partnerProfileDetails?.bankAccountNumber || "";
        const detailsFor = partnerResponse?.partnerProfileDetails?.detailsFor || "";
        const otherPanTypeDetail = partnerResponse?.partnerProfileDetails?.otherPanTypeDetail || "";
        const isFirstTime = panType === "" && panNumber === "" && gstNumber === "" && bankAccountNumber === "" && ifscCode === "" && (arnNumber === "" || arnNumber === null || arnNumber === 'null');
        const bankAccountVerified = partnerResponse?.partnerProfileDetails?.bankAccountVerified;
        const bankLastAddedOn = partnerResponse?.lastUpdatedOn;
        const bankAddedOn = getDateMonthYearFromEpoch(bankLastAddedOn);
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        await AsyncStorage.setItem("activeIndexTab", undefined);
        return Promise.resolve(template(name, phoneNumber, emailId, companyName, arnNumber, panType, gstNumber, panNumber, ifscCode, bankAccountNumber, detailsFor, isFromStartPayoutonDashboard, passwordHash, partnerAccountType, isFirstTime, otherPanTypeDetail, showNewRmContactButton, rmData, bankAccountVerified, isFromPayOutDetails, bankAddedOn, getActiveIndexTab));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION_ACCOUNT.ON_LOAD]: onLoad,
        [ACTION_ACCOUNT.ON_ENTER_PROFILE_DETAILS]: onEnteringProfileData,
        [ACTION_ACCOUNT.ON_ENTER_PAYOUT_DETAILS]: onEnteringPayoutDetails,
        [ACTION_ACCOUNT.ON_SAVE_PROFILE_DETAILS]: onSaveProfileDetails,
        [ACTION_ACCOUNT.ON_SAVE_PAYOUT_DETAILS]: onSavePayoutDetails,
        [ACTION_ACCOUNT.ON_SELECT_PAN_TYPE]: onSelectPanType,
        [ACTION_ACCOUNT.ON_CLICK_PROFILE_EDIT]: onEditProfileDetails,
        [ACTION_ACCOUNT.ON_CLICK_PAYOUT_EDIT]: onEditPayoutDetails,
        [ACTION_ACCOUNT.ON_SET_NEW_PASSWORD]: onSetNewPassword,
        [ACTION_ACCOUNT.GET_REENTERED_PASSWORD]: getReEnteredPassword,
        [ACTION_ACCOUNT.ENTER_PASSWORD]: getEnteredPassword,
        [ACTION_ACCOUNT.SEND_PASSWORD]: sendPasswordToBackend,
        [ACTION_ACCOUNT.TOGGLE_PASSWORD]: toggleAction,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
        [ACTION.NAVIGATE_PAYOUT_DETIALS]: navigateToPayoutDetails,
        [ACTION_ACCOUNT.ON_ENTER_ARN_DETAILS]: onEnterArnDetails,
    },
    action: {
        type: ACTION_ACCOUNT.ON_LOAD,
        routeId: ROUTE.MY_ACCOUNT,
        payload: {},
    },
};
